module.exports = __webpack_public_path__ + "static/media/arrow-right.fe8ae2d5.svg";